import classNames from 'classnames';
import React, { CSSProperties, useMemo } from 'react';
import { Color } from '../../enums/Color.enum';
import { SelectionType } from '../../enums/SelectionType.enum';
import { Direction, MannequinPhoto, useProductAssets } from '../../hooks/useProductAssets';
import { useProductSelection } from '../../hooks/useProductSelection';
import { ViewProduct } from '../../models/ViewProduct.model';
import { DivButton } from '../../root/components/DivButton';
import styles from './ProductSelector.module.scss';

interface Props {
  product: ViewProduct;
  selectionType: SelectionType;
  selectionKey: string;
  active?: boolean;
  style?: CSSProperties;
}

const prioritizeDarkColors = (a: MannequinPhoto, b: MannequinPhoto): -1 | 0 | 1 => {
  switch (true) {
    case a.color === Color.Runway && b.color !== Color.Runway:
      return -1;
    case a.color !== Color.Runway && b.color === Color.Runway:
      return 1;
    case a.color === Color.Vamp && b.color !== Color.Vamp:
      return -1;
    case a.color !== Color.Vamp && b.color === Color.Vamp:
      return 1;
    case a.color === Color.JetBlack && b.color !== Color.JetBlack:
      return -1;
    case a.color !== Color.JetBlack && b.color === Color.JetBlack:
      return 1;
    default:
      return 0;
  }
};

export const ProductSelector: React.FC<Props> = ({ active, product, selectionType, selectionKey, style }) => {
  const assets = useProductAssets(product);
  const { setHandle } = useProductSelection(selectionType, selectionKey);

  const imgSrc = useMemo(() => assets.mannequinPhotos.filter((p) => p.direction === Direction.Front).sort(prioritizeDarkColors)[0]?.src, [assets]);

  return (
    <DivButton className={styles.container} onClick={() => setHandle(product.handle)} style={style} label={`Select product: ${product.title}`}>
      {imgSrc && <img alt={`${product.title}`} src={imgSrc} style={{ maxHeight: 70 }} />}
      <span className={classNames(styles.productTitle, { [styles.active]: active })}>{product.title}</span>
    </DivButton>
  );
};

export default ProductSelector;
